import React from 'react';

import { Button } from '@components/Button';
import { DevLayout } from '@components/dev/DevLayout';
import { useJwtLogin } from '@hooks/mutation/useJwtLogin';
import { useUser } from '@hooks/queries/useUser';
import { useFormUtils } from '@hooks/useFormUtils';
import { AuthManager } from '@store/AuthManager';
import { makeMuiStyles } from '@styles';
import { getConfig } from '@utils/config';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';

const useStyles = makeMuiStyles((theme, common) => ({
  buttonContainer: {
    ...common.flexInline,
    columnGap: '1rem',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

export const Accounts: React.FC = observer(() => {
  const classes = useStyles();

  const login = useJwtLogin();

  const user = useUser(undefined, {
    enabled: AuthManager.shared.isLoggedIn,
  });

  const accounts = getConfig().dev?.accounts ?? [];

  const history = useHistory();

  const { renderAlertsAndSpinnerModal } = useFormUtils({ mutations: [login] });

  return (
    <DevLayout>
      <div style={{ padding: '1rem' }}>
        {renderAlertsAndSpinnerModal()}

        <h1>Login as...</h1>
        {accounts.length === 0 && (
          <h2>No accounts available and VITE_APP_STAGE={import.meta.env.VITE_APP_STAGE}</h2>
        )}
        <ul>
          {accounts.map((account) => (
            <li
              key={account.email}
              style={{ cursor: 'pointer', color: user.data?.email === account.email ? 'blue' : '' }}
            >
              {account.tag}
              <ul>
                <li>{account.email}</li>
                <li>{account.password}</li>
              </ul>

              <div className={classes.buttonContainer}>
                <Button
                  text="Login"
                  color="primary"
                  size="small"
                  onClick={async () => {
                    try {
                      await login.mutateAsync({
                        ...account,
                      });

                      history.push('/');
                    } catch (e) {
                      alert(e);
                    }
                  }}
                />

                <Button
                  text="Copy Email"
                  color="primary"
                  size="small"
                  onClick={async () => {
                    await navigator.clipboard.writeText(account.email);
                    alert(`Copied ${JSON.stringify(account.email)}`);
                  }}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </DevLayout>
  );
});
